export const Xing = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.0364 0H15.9636C7.14713 0 0 7.14713 0 15.9636V16.0364C0 24.8529 7.14713 32 15.9636 32H16.0364C24.8529 32 32 24.8529 32 16.0364V15.9636C32 7.14713 24.8529 0 16.0364 0Z" fill="#006567" />
    <path d="M25.3333 6.66675H20.6816L13.7712 18.8255L18.2238 26.6667H22.8755L18.4229 18.8255L25.3333 6.66675ZM11.8472 10.4167H7.46183L9.99925 14.9055L6.66663 20.4167H11.052L14.3847 14.9055L11.8472 10.4167Z" fill="white" />
  </svg>
)
